import Alpine from "alpinejs";
import isEditMode from "../../modules/isEditMode";

Alpine.magic("isEditMode", () => () => {
    return isEditMode();
});
